/* eslint-disable @typescript-eslint/triple-slash-reference */
/* eslint-disable no-undef */
/// <reference path="../node_modules/@types/facebook-js-sdk/index.d.ts" />
import { Injector, HttpService, LocalStorageService } from 'Core';
import {
  TpsReportDataService,
  MtmReportDataService,
  ReportDataConversionService,
  BallTrajectoryService,
} from 'Services';
import { Start } from './start';

/**
 * @description We follow Dependency Injection (DI) pattern.
 * We register the implementation of the interface here.
 * Later on in the code, we will use the interface to access the implementation
 * without knowing which implementation we are using.
 * Example: const storageService = Injector.get<IStorageService>('IStorageService');
 */

// if (!process.env.REACT_APP_ENV || process.env.REACT_APP_ENV === 'dev') {
//   //setup DI
//   Injector.register('IStorageService', LocalStorageService);
//   Injector.register('IHttpService', HttpService);
//   Injector.register('IBallTrajectoryService', BallTrajectoryService);
//   Injector.register('IReportDataConversionService', ReportDataConversionService);
//   Injector.register('IReportDataService', ReportDataService);
// }

if (process.env.REACT_APP_ENV === 'tps') {
  //setup DI
  Injector.register('IStorageService', LocalStorageService);
  Injector.register('IReportDataConversionService', ReportDataConversionService);
  Injector.register('IReportDataService', TpsReportDataService);
}

if (process.env.REACT_APP_ENV === 'web' || process.env.REACT_APP_ENV === 'dev') {
  //setup DI
  Injector.register('IStorageService', LocalStorageService);
  Injector.register('IHttpService', HttpService); // not available in TPS
  Injector.register('IBallTrajectoryService', BallTrajectoryService); // not available in TPS
  Injector.register('IReportDataConversionService', ReportDataConversionService);
  Injector.register('IReportDataService', MtmReportDataService);
}

if (process.env.REACT_APP_ENV !== 'tps') {
  FB.init({
    appId: '123883180986177',
    version: 'v2.9',
    xfbml: true,
  });
}

//start the show
Start.main();
